// @flow
export const REQUEST_CONTENT_PAGE = "REQUEST_CONTENT_PAGE";
export const requestContentPage = (url, locale) => ({
  type: REQUEST_CONTENT_PAGE,
  url,
  locale
});

export const REQUEST_CONTENT_PAGE_SUCCESS = "REQUEST_CONTENT_PAGE_SUCCESS";
export const requestContentPageSuccess = data => ({
  type: REQUEST_CONTENT_PAGE_SUCCESS,
  data
});

export const REQUEST_CONTENT_PAGE_FAILED = "REQUEST_CONTENT_PAGE_FAILED";
export const requestContentPageFailed = error => ({
  type: REQUEST_CONTENT_PAGE_FAILED,
  error
});



// WEBPACK FOOTER //
// ./src/redux/actions/contentPage.js